import React from "react";
import PropTypes from "prop-types";
import HelperText from "../../../../../components/atoms/HelperText";
import NumberToPrecision from "../../../../../components/atoms/NumberToPrecision/NumberToPrecision";
import { getZscoreColor } from "../../common/helpers";
import GnomadEntry from "../GnomadEntry";

function GnomadVariantsTable({ gnomadEntry }) {
  if (!gnomadEntry) return null;

  return (
    <table className="varsome-table tw-break-words tw-my-12">
      <thead>
        <tr>
          <th width="10%" className="tw-text-left tw-font-bold" />
          <th width="10%" className="tw-text-left tw-font-bold">
            Z-Score <HelperText fieldDescriptionKey="Z-Score" />
          </th>
          <th width="10%" className="tw-text-left tw-font-bold">
            Observed <HelperText fieldDescriptionKey="Observed" />
          </th>
          <th width="10%" className="tw-text-left tw-font-bold">
            Expected <HelperText fieldDescriptionKey="Expected" />
          </th>
          <th width="11%" className="tw-text-left tw-font-bold">
            Observed/Expected{" "}
            <HelperText fieldDescriptionKey="Observed/Expected" />
          </th>
          <th width="12%" className="tw-text-left tw-font-bold">
            Lower
            <br />
            Bound
            <HelperText fieldDescriptionKey="Lower Obs/Exp Bound" />
          </th>
          <th width="12%" className="tw-text-left tw-font-bold">
            Upper
            <br />
            Bound
            <HelperText fieldDescriptionKey="Upper Obs/Exp Bound" />
          </th>
          <th width="10%" className="tw-text-left tw-font-bold">
            Mutation Rate <HelperText fieldDescriptionKey="Mutation Rate" />
          </th>
          <th width="15%" className="tw-text-left tw-font-bold">
            Total Possible in Transcript{" "}
            <HelperText fieldDescriptionKey="Total Possible in Transcript" />
          </th>
        </tr>
      </thead>
      <tbody className="varsome-text-center">
        {gnomadEntry.variants.map((x) => {
          return (
            <tr key={x.name}>
              <td className="tw-text-left tw-font-bold">{x.name}</td>
              <td
                className="tw-text-left"
                style={{ color: getZscoreColor(x.zScore) }}
              >
                <NumberToPrecision value={x.zScore} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.observed} digits={0} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.expected} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.observedExpected} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.observedExpectedLower} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.observedExpectedUpper} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.mutationRate} E={0} />
              </td>
              <td className="tw-text-left">
                <NumberToPrecision value={x.totalPossible} digits={0} E={0} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

GnomadVariantsTable.propTypes = {
  gnomadEntry: PropTypes.instanceOf(GnomadEntry),
};

GnomadVariantsTable.defaultProps = {
  gnomadEntry: null,
};

export default React.memo(GnomadVariantsTable);
